import React, { useEffect } from 'react';

const ActionMenu = ({ isOpen, children, row = [] }) => {
  const menuClassname = isOpen ? 'action-menu--visible' : 'action-menu';
  return <div className={menuClassname}>{children}</div>;
};

export default ActionMenu;
